<template>
  <q-btn
    icon="fa fa-question-circle"
    label="Support"
    v-bind="$attrs"
    @click="show"
    :dense="$q.screen.lt.md"
    class="support-btn"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { openDrawer } from '@/layout';
import Info from './Info.vue';

export default defineComponent({
  methods: {
    show(): void {
      openDrawer({ component: Info });
    },
  },
});
</script>
